import { ManualtrackingData } from "../../components/datatable/Manual_tracking";

const Manualtracking = () => {
  return <ManualtrackingData />;
};

export default Manualtracking;
